import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import PaymentFailedForm from 'app/modules/payment/components/PaymentFailedForm';
import Loader from 'app/components/Loader';

@withRouter
@inject('store')
@observer
class CreditPaymentFailed extends Component {
    constructor() {
        super();
        this.state = {
            total: null,
        };
    }

    componentDidMount() {
        const { payment: { credit } } = this.props.store;
        const { params: { orderId } } = this.props.match;

        credit.extractTotalByOrderId(orderId)
            .then((res) => {
                this.setState({ total: res });
                credit.fetchPrinterStatus()
            })
    }

    render() {
        const { payment: { credit: { isTotalSet } } } = this.props.store;

        return (
            <Fragment>
                {!isTotalSet && !this.state.total ?
                    <Loader fullScreen={true} /> : <PaymentFailedForm total={this.state.total} />
                }
            </Fragment>
        )
    }
}

export default CreditPaymentFailed;
